module.exports = {
  "props": [
    {
      "name": "locales",
      "default": "{ en: VuetifyLocale }",
      "type": "Record<string, VuetifyLocale>",
      "description": {
        "en": "Available locales",
        "ja": "使用可能なロケール",
        "zh-Hans": "可用区域"
      }
    },
    {
      "name": "current",
      "default": "en",
      "type": "string",
      "description": {
        "en": "Current locale",
        "ja": "現在のロケール",
        "zh-Hans": "当前本地化:"
      }
    }
  ],
  "functions": [
    {
      "name": "t",
      "default": "(key: string, ...params: Array<string | number>): string",
      "type": "Function",
      "description": {
        "en": "Translation function used internally",
        "ja": "内部的に使用される翻訳関数",
        "zh-Hans": "内部使用的翻译函数"
      }
    }
  ],
  "name": "internationalization"
}